import { all, takeLatest, call, put, select } from "redux-saga/effects";
import {
  PUBLISH_CITY,
  PUBLISH_GEOFENCE,
  setErrorToastMessage,
  setSuccessToastMessage,
  SET_CITY_NAME,
  setLoaderModal,
  setBounds,
  setAvailableCities,
  setGeofences,
  addJustPublishedGeofence,
  PUBLISH_SELECTED_ID_FENCE,
  DELETE_SELECTED_ID_FENCE,
  removeSelectedFence,
  FETCH_AVAILABLE_CITIES,
  FETCH_ORDER_LOCS,
  setOrderpins,
  setUserAuthenticated,
  setReplayOnAuthentication,
  FETCH_ADDITIONAL_CITY_FENCES,
  addAddtionalCityGeofences
} from "../actions";
import {
  publishCity,
  loadCity,
  publishGeofence,
  updateGeofence,
  deleteGeofence,
  loadAvailableCitiesList,
  loadOrderLocs
} from "../../../api/geofence/city";
import moment from "moment";

export function* publishCityTask(action) {
  const data = yield select(({ geofence }) => ({
    cityBounds: geofence.cityBounds,
    newCityName: geofence.newCityName,
    toPublishFence: geofence.toPublishFence
  }));
  try {
    const result = yield call(publishCity, data);
    yield put(addJustPublishedGeofence(result.data.geofence));
    yield put(setSuccessToastMessage("City Published"));
  } catch (e) {
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    console.log(e.response.data.message);
    yield put(setErrorToastMessage(e.response.data.message));
  }
}

export function* watchPublishCity() {
  yield takeLatest(PUBLISH_CITY, publishCityTask);
}

export function* loadCityTask(action) {
  if (!action.payload) {
    return;
  }
  try {
    yield put(setLoaderModal(true));
    const { bounds, geofences, availableCities } = yield call(
      loadCity,
      action.payload
    );
    yield put(setLoaderModal(false));
    yield put(setBounds(bounds));
    yield put(setAvailableCities(availableCities));
    yield put(setGeofences(geofences));
  } catch (e) {
    console.log(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setLoaderModal(false));
    yield put(setErrorToastMessage(e.response.data.message));
  }
}

export function* watchSelectCity() {
  yield takeLatest(SET_CITY_NAME, loadCityTask);
}

export function* publishGeofenceTask(action) {
  const data = yield select(({ geofence }) => ({
    cityName: geofence.currentCityName,
    toPublishFence: geofence.toPublishFence
  }));
  try {
    const result = yield call(publishGeofence, data);
    yield put(addJustPublishedGeofence(result.data.geofence));
    yield put(setSuccessToastMessage("Geofence Published"));
  } catch (e) {
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    console.log(e.response.data.message);
    yield put(setErrorToastMessage(e.response.data.message));
  }
}

export function* watchPublishGeofence() {
  yield takeLatest(PUBLISH_GEOFENCE, publishGeofenceTask);
}

export function* updateGeofenceTask(action) {
  const geofence = yield select(({ geofence }) => geofence.toPublishFence);
  try {
    const result = yield call(updateGeofence, geofence);
    yield put(addJustPublishedGeofence(result.data.geofence));
    yield put(setSuccessToastMessage("Geofence Updated"));
  } catch (e) {
    console.log(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    console.log(e.response.data.message);
    yield put(setErrorToastMessage(e.response.data.message));
  }
}

export function* watchPublishSelectedIdFence() {
  yield takeLatest(PUBLISH_SELECTED_ID_FENCE, updateGeofenceTask);
}

export function* deleteGeofenceTask(action) {
  const geofence = yield select(({ geofence }) =>
    geofence.geofences.find(e => e._id === geofence.selectedPolygonId)
  );
  try {
    yield put(setLoaderModal(true));
    yield call(deleteGeofence, geofence);
    yield put(removeSelectedFence());
    yield put(setLoaderModal(false));
    yield put(setSuccessToastMessage("Geofence Deleted"));
  } catch (e) {
    yield put(setLoaderModal(false));
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    console.error(e.response.data.message);
    yield put(setErrorToastMessage(e.response.data.message));
  }
}

export function* watchDeleteSelectedIdFence() {
  yield takeLatest(DELETE_SELECTED_ID_FENCE, deleteGeofenceTask);
}

export function* fetchCitiesTask(action) {
  try {
    yield put(setLoaderModal(true));
    const result = yield call(loadAvailableCitiesList);
    yield put(setLoaderModal(false));
    yield put(setAvailableCities(result.data.availableCities));
  } catch (e) {
    yield put(setLoaderModal(false));
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    console.error(e.response.data.message);
    yield put(setErrorToastMessage(e.response.data.message));
  }
}

export function* watchFetchCities() {
  yield takeLatest(FETCH_AVAILABLE_CITIES, fetchCitiesTask);
}

export function* fetchOrderLocsTask(action) {
  let cityName;
  try {
    cityName = yield select(({ geofence }) => geofence.currentCityName);
    if (action.payload) {
      cityName = action.payload;
    }
    const { dateRange, last30Days } = yield select(
      ({ geofence }) => geofence.orderpinsFilter
    );
    let reqDataDates;
    if (dateRange && !last30Days) {
      reqDataDates = dateRange.map(e => e.format());
    } else if (last30Days) {
      reqDataDates = [
        moment()
          .subtract(30, "days")
          .format(),
        moment().format()
      ];
    }

    yield put(setLoaderModal(true));
    const result = yield call(loadOrderLocs, cityName, reqDataDates);
    yield put(setOrderpins(result.data.orders));
    yield put(setLoaderModal(false));
  } catch (e) {
    yield put(setLoaderModal(false));
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    console.error(e.response.data.message);
    yield put(setErrorToastMessage(e.response.data.message));
  }
}

export function* watchFetchOrderLocs() {
  yield takeLatest(FETCH_ORDER_LOCS, fetchOrderLocsTask);
}

export function* loadAddtionalCityFencesTask(action) {
  if (!action.payload) {
    return;
  }
  try {
    yield put(setLoaderModal(true));
    const geofences = yield all(action.payload.map(e => call(loadCity, e)));
    yield put(setLoaderModal(false));
    for (let i = 0; i < geofences.length; i++) {
      yield put(
        addAddtionalCityGeofences({
          geofences: geofences[i].geofences,
          cityName: action.payload[i]
        })
      );
    }
  } catch (e) {
    console.log(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setLoaderModal(false));
    yield put(setErrorToastMessage(e.response.data.message));
  }
}

export function* watchAdditionalCity() {
  yield takeLatest(FETCH_ADDITIONAL_CITY_FENCES, loadAddtionalCityFencesTask);
}
